import { Box } from '@mui/material';
import SideMenu from '../../SideMenu/V2';
import ProfileDrawer from '../../ProfileDrawer';
import SiteFooter from '../../SiteFooter';
import { useUrlChecker } from '../../../hooks/useUrlChecker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import SiteHeaderV2 from '../../SiteHeader/V2';
import SiteFooterPublic from '../../SiteFooterPublic';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { routes } from '../../../constants/Constants';
import { ToastProvider } from '../../../components/Toast';
import { CoreWrapper } from '@/components/wrapper/CoreWrapper';

type Props = {
  children: JSX.Element[] | JSX.Element;
};

const PageWrapper = ({ children }: Props) => {
  const { isPublic } = useUrlChecker();
  const preRegister = isPublic || window.location.pathname === routes.unitsOwnedEnroll;

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <CoreWrapper>
        <ToastProvider>
          <Box sx={{ display: 'flex', flexDirection: 'row', minHeight: '100vh' }}>
            {preRegister ? null : <SideMenu />}
            <div id="page-container" style={{ flex: 1 }}>
              <SiteHeaderV2 />
              <Box
                sx={{
                  px: { xs: 2, md: isPublic ? 0 : 2 },
                  transition: 'margin 0.3s linear',
                }}
              >
                <Box sx={{ margin: { xl: '0 auto' }, minHeight: 'calc(100vh - 356px)' }}>
                  {children}
                </Box>
                {isPublic ? null : <SiteFooter />}
              </Box>
              {isPublic ? <SiteFooterPublic /> : null}
              <ProfileDrawer />
            </div>
          </Box>
        </ToastProvider>
      </CoreWrapper>
    </LocalizationProvider>
  );
};

export default PageWrapper;
